import React, { useState, useEffect, useContext } from 'react'


import { Link,useParams } from 'react-router-dom'
import * as Constants from '../../constants';
import { ShareContext } from '../../context/ShareContext'
import BackLoader from '../../components/backloader'
import { useNavigate } from 'react-router-dom'
function ConfirmAffidavitPayment() {
      const {refid} = useParams();
       const {  activePage, token, profile,frequentData,setIsExpired, setAlert} = useContext(ShareContext);
      const navigate = useNavigate();
        const [isLoading, setIsLoading] = useState(false);
       useEffect(() => {     
                  
        //verifiy payment 
        onVerifyPayment();

                
      }, [refid])

       const onVerifyPayment= async()=>{ //doctype=upline always this one
              //for account registration DocumentView
              const url=`${Constants.apiUrl}/payment/affidavitverify/${refid}`
          
              console.log(`the calling url ${url}`);
              try {
                  setIsLoading(true);
                  const resp = await fetch(url, { 
                    method: 'GET',
                    headers: {
                      'Content-Type': 'application/json',
                     Authorization: `Bearer ${token}`,
                    },
                  });
                  
                  const data = await resp.json();
                  setIsLoading(false);
                 // onLoad();
                 console.log(data);
                  if(data.code==0 ){
                    // navigate(`/AffidavitDocuments/${data.docId}/edit/${data.uplineId}`)
                     setAlert({open:true, title:'Payment Status', subtitle:'Payment successful', code:data.code, data})
                     var a={id: data.docId,caseTitle: 'N/A',caseNumber:'N/A', type:'affidavit',caseFeeId: data.caseFeeId   };
                       navigate("/view-document-template", {state: {item:a}});
      
      
                  }else{
                     // setAlert({open:true, title:'Payment Status', subtitle:data.status, code:data.code, data, onOk})
                  }
                } catch (error) {
                  setIsLoading(false);
                  console.error(error);
                  
                }
          }

  return (
    <div>
      <h1>Profile Page</h1>
      {/* Add your login form UI here */}
    </div>
  );
}

export default ConfirmAffidavitPayment;